import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

import { useAppDispatch, useAppSelector } from '../../state/hooks';
import { resetSearchFilters, saveSearchFilters } from '../../state/features/filterSlice';
import { useFilters } from './useFilters';
import FilterDrawer from './FilterDrawer';

const SearchFilterDrawer = ({
    isOpen,
    onClose,
}: {
    isOpen: boolean;
    onClose: () => void;
}): React.JSX.Element => {
    const dispatch = useAppDispatch();

    const queryFilters = useFilters();

    const searchFilters = useAppSelector((state) => { return state.filters.searchFilters; });

    /** when loading, or if query filters change, automatically update the search filters */
    useEffect(() => {
        dispatch(saveSearchFilters(queryFilters));
    }, [dispatch, queryFilters]);

    return (
        <FilterDrawer
            initialFilters={searchFilters}
            isOpen={isOpen}
            onClose={onClose}
            resetFilters={(): void => {
                dispatch(resetSearchFilters());
            }}
            applyFilters={(filters): void => {
                dispatch(saveSearchFilters(filters));
                toast.info('Search filters saved');
            }}
            title='Search Filters'
        />
    );
};

export default SearchFilterDrawer;
